import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    // Счетчик активных запросов
    private activeRequestsCount = signal(0);

    // Вычисляемый сигнал: true, если есть хотя бы один активный запрос
    public isLoading = computed(() => this.activeRequestsCount() > 0);

    show(): void {
        //см. комментарий
        queueMicrotask(() => {
            this.activeRequestsCount.update((count) => count + 1);
        });
    }

    hide(): void {
        //см. комментарий
        queueMicrotask(() => {
            this.activeRequestsCount.update((count) => Math.max(0, count - 1));
        });
    }
}

/*
--- КОММЕНТАРИЙ ---
Представьте, что вы вызываете refresh() внутри effect (например, чтобы автоматически перезапрашивать данные при изменении paramsSignal).
Вот что происходит по тикам (JavaScript Event Loop):
effect начинает выполнение (Angular помечает контекст как "реактивный").
Вызывается refresh() → стартует HTTP-запрос.
Запрос попадает в интерсептор.
Интерсептор синхронно вызывает loadingService.show().
Если запрос падает мгновенно (или это мок, или кэш, или синхронная ошибка валидации), срабатывает finalize → синхронно вызывается loadingService.hide().
Ошибка идет дальше в createQuery → срабатывает catchError → синхронно вызывается error.set(err) или data.set(v).
💥 БАБАХ! Angular видит, что сигнал изменяется (set), пока effect из шага 1 всё ещё выполняется (не завершился). Выбрасывается NG0600.
Без интерсептора цепочка могла быть чуть асинхроннее (из-за внутренней работы HttpClient), и effect успевал завершиться до того, как срабатывал error.set. Интерсептор добавил синхронные операции (show/hide), "схлопнув" всю цепочку в один синхронный тик.
 */
